/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { urls } from '@auteco/constants'
import CardActions from 'src/components/sharedComponents/Card/CardFooter'
import Card from 'src/components/sharedComponents/Card/Card'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import { ScreenLoading2 } from 'src/components/sharedComponents/ScreenLoading'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import Search from 'src/components/sharedComponents/SearchInput'
import choseColors from 'src/utils/chooseColor'
import {
  ImgWrapper,
  Img,
  Content,
  Title,
  DescriptionItem,
  Button,
  useStyles,
} from './styles'

const DataStudioReports = ({ reports, loading, onChangeInput }) => {
  const classes = useStyles()
  if (loading) {
    return <ScreenLoading2 />
  }

  return (
    <main style={{ margin: '10px' }}>
      {reports.length > 1 && (
        <CardTitle
          title="Reportes DataStudio "
          subTitle="Seleccione un reporte"
        />
      )}
      {reports.length === 0 && (
        <>
          <Grid justifyContent="center" container>
            <Grid item xs={6}>
              <Card>
                <CardHeader color="customAuteco">
                  <h3>No tienes reportes asignados en este momento</h3>
                  <p>Contacta al administrador </p>
                </CardHeader>
                <Card>
                  <ImgWrapper>
                    <Img id="alt" src={urls.DEFAULT_IMG} />
                  </ImgWrapper>
                </Card>
              </Card>
            </Grid>
          </Grid>
        </>
      )}
      <Search handleSearch={onChangeInput} />
      <Grid container spacing={2}>
        {Array.isArray(reports) &&
          reports.map((value) => (
            <Fragment key={value.id}>
              <Grid item xs={12} md={6} lg={4}>
                <Card
                  className={classes.root}
                  style={{ border: `2px solid ${choseColors(value.tipo)}` }}
                >
                  <CardBody>
                    <Content>
                      <Title>{value.nombre}</Title>
                      <article>
                        <DescriptionItem>
                          <dt style={{ fontWeight: 'bold' }}>
                            Detalle del informe:
                          </dt>
                          <dd>{value.descripcion}</dd>
                        </DescriptionItem>
                      </article>
                    </Content>
                  </CardBody>
                  <CardActions>
                    <Button
                      rel="noopener noreferrer"
                      href={value.url}
                      target="_blank"
                    >
                      Ver informe
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Fragment>
          ))}
      </Grid>
    </main>
  )
}

export default DataStudioReports
